import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ACTIONS } from './states';
export var reducer = function reducer(pluginState, action) {
  var _pluginState$proactiv, _pluginState$proactiv2;
  switch (action.type) {
    case ACTIONS.UPDATE_PLUGIN_STATE:
      return _objectSpread(_objectSpread({}, pluginState), action.data);
    case ACTIONS.TOGGLE_SPELLING_AND_GRAMMAR_ENABLED:
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        toggleCount: action.data.toggleCount,
        isSpellingAndGrammarEnabled: !pluginState.isSpellingAndGrammarEnabled
      }, pluginState.isSpellingAndGrammarEnabled && {
        docChangeCountUntilLimit: 0
      });
    case ACTIONS.DISABLE_NEED_SPELLING_AND_GRAMMAR:
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        proactiveAIBlocks: (_pluginState$proactiv = pluginState.proactiveAIBlocks) === null || _pluginState$proactiv === void 0 ? void 0 : _pluginState$proactiv.map(function (block) {
          if (pluginState.splitParagraphIntoSentences) {
            var _block$sentences;
            return _objectSpread(_objectSpread({}, block), {}, {
              sentences: (_block$sentences = block.sentences) === null || _block$sentences === void 0 ? void 0 : _block$sentences.map(function (sentence) {
                if (action.data.skippedChunkIds.includes(sentence.id)) {
                  return _objectSpread(_objectSpread({}, sentence), {}, {
                    needSpellingAndGrammarCheck: false,
                    needSGCheckForDocChecker: false
                  });
                }
                return sentence;
              })
            });
          }
          if (action.data.skippedChunkIds.includes(block.id)) {
            return _objectSpread(_objectSpread({}, block), {}, {
              needSpellingAndGrammarCheck: false,
              needSGCheckForDocChecker: false
            });
          }
          return block;
        })
      });
    case ACTIONS.UPDATE_CHUNK_METADATA:
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        proactiveAIBlocks: (_pluginState$proactiv2 = pluginState.proactiveAIBlocks) === null || _pluginState$proactiv2 === void 0 ? void 0 : _pluginState$proactiv2.map(function (block) {
          if (pluginState.splitParagraphIntoSentences) {
            var _block$sentences2;
            return _objectSpread(_objectSpread({}, block), {}, {
              sentences: (_block$sentences2 = block.sentences) === null || _block$sentences2 === void 0 ? void 0 : _block$sentences2.map(function (sentence) {
                if (action.data.chunkId === sentence.id) {
                  return _objectSpread(_objectSpread({}, sentence), {}, {
                    metadata: action.data.metadata
                  });
                }
                return sentence;
              })
            });
          }
          if (action.data.chunkId === block.id) {
            return _objectSpread(_objectSpread({}, block), {}, {
              metadata: action.data.metadata
            });
          }
          return block;
        })
      });
    case ACTIONS.START_SPELLING_AND_GRAMMAR:
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        isSpellingAndGrammarEnabled: true,
        toggleCount: pluginState.isSpellingAndGrammarEnabled ? pluginState.toggleCount : pluginState.toggleCount + 1
      });
    default:
      return pluginState;
  }
};